<template>
    <div class="position-box">
      <div class="head">
        <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
        <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
        <div class="lang" @click="lang">{{$t('safe.yysz')}}</div>
      </div>
        <div class="cotainer">
            <h1 class="h1">{{$t('lg.welcome')}}</h1>
            <!-- <h3 class="h3">区块链交易中心</h3> -->
            <div class="tips">{{$t('xgdlmm.zh')}}</div>
            <div class="input-box">
              <input class="input" type="text" v-model="userName" :placeholder="$t('lg.paccount')">
              <img v-if="!theme" v-show="userName" src="@/assets/Log-In_delete.png" class='icon' @click="clear" />
              <img v-else v-show="userName" src="@/assets/theme/close2.png" class='icon' @click="clear" />
            </div>
            <div class="tips">{{$t('xgdlmm.mm')}}</div>
            <div class="input-box input-pwd">
              <input class="input" ref="input" v-model="passwords" type="password" :placeholder="$t('lg.ppwd')">
              <template v-if="isPwd">
                <img v-if="!theme" v-show="passwords" src="@/assets/Log-In_close-eyes.png" class='icon' @click="shpass" />
                <img v-else v-show="passwords" src="@/assets/theme/eyes.png" class='icon' @click="shpass" />
              </template>
               <template v-else>
                <img v-if="!theme" v-show="passwords" src="@/assets/Log-In_eyes.png" class='icon' @click="shpass" />
                <img v-else v-show="passwords" src="@/assets/theme/eyes2.png" class='icon' @click="shpass" />
              </template>
            </div>
            <ul class="item-box">
              <li class="text t2" v-show="temp_user" @click="create">{{$t('tipsNew.cjxnzh')}}</li>
              <router-link tag="li" class="text" to="/forgetPwd">{{$t('lg.ftpwd')}}</router-link>
              <!-- <router-link tag="li" class="text" to="/language">{{$t('lg.language')}}</router-link> -->
            </ul>
            <button class="btn-login btn-bg" @click="login">{{$t('lg.lgs')}}</button>
            <button class="btn-login2 btn-bg" @click="login2">{{$t('langNew.qbdl')}}</button>
            <li tag="div" class="t1">{{$t('lg.noaccount')}}
              <router-link class="t2" tag="span" to="/reg">{{$t('lg.qregister')}}</router-link>
              <img class="kefu" @click="service" src="@/assets/new2/kefu2.png" alt="">
            </li>
        </div>
    </div>
</template>

<script>
export default {
    name: 'login',
    data () {
        return {
          theme: false,
          isPwd: true,
          userName: '',
          passwords: '',
          temp_user: false,
          index: 0,
          service_link: '',
          address: '',
          isMn: false
        }
    },
    created(){
      this.isMn = localStorage.getItem('isMn') || false;
      this.theme = JSON.parse(localStorage.getItem('theme'));
      localStorage.removeItem('regCheck');
      this.getCheckcode();
      this.getParams();
      // this.getEthLogin();
    },
    mounted() {
      $("input").keyup(function(){	//去掉空格
        $(this).val($(this).val().replace(/[, ]/g,''));
      });
      this.userName = localStorage.getItem('account') || '';
      this.passwords = localStorage.getItem('pwd') || '';
    },
    methods: {
      back(){
        this.$router.push('/index')
      },
      lang(){
        this.$router.push('/language')
      },
      login2(){
        if(window.ethereum){
          this.getAddress();
        }else{
          this.$toast.center(this.$t('langNew.qbdlts'));
          return;
        }
      },
      service(){
        if(!this.service_link) return;
        var kfUrl;
        var userId = localStorage.getItem('userId');
        if(userId){
          var userInfo = {
            "uid":userId,
            "name":userId
          }
          var userUrl = encodeURIComponent(JSON.stringify(userInfo));
          kfUrl = this.service_link + "&userInfo=" + userUrl;
        }else{
          kfUrl = this.service_link;
        }
        this.$router.push({ path: '/service', query: { url: kfUrl } })
      },
      getParams(){
        this.$ajax.get('/web/getParam',{token: 1}).then((res) => {
            let resData = res.data.data;
            this.service_link = resData.filter((item) =>{
                if(item.key == 'online_service'){
                    return item
                }
            })[0].value;
        }).catch(function(err){
            console.log(err)
        })
      },
      getCheckcode(){
        let params = {
            token: 1
        }
        this.$ajax.get('/web/reg_checkcode',{params}).then((res) => {
            let resData = res.data.data;
            this.temp_user = resData.temp_user;
        }).catch(function(err){
            console.log(err)
        })
      },
      create(){
        if(!this.isMn){
          let params = {
              token:1,
          }
          this.$ajax.get('/web/tempLogin',{params}).then((res) => {
            let resData = res.data;
              if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                  this.isMn = true;
                  localStorage.setItem('token',resData.data.token);
                  localStorage.removeItem('sbsxbz');
                  localStorage.removeItem('sbsxIcon');
                  localStorage.setItem('isMn',true);
                  localStorage.setItem('userId',resData.data.id);
                  this.$toast.center(this.$t('status.statusText')[2]);
                  setTimeout(() => {
                    this.$router.push('/index')
                  }, 1000)
              }else{
                  this.$toast.center(resData.message);
                  return;
              }
          }).catch(function(err){
              console.log(err)
          })
        }else{
          this.loginOut();
        }
      },
      loginOut(){
        this.isMn = false;
        localStorage.removeItem('token');
        localStorage.removeItem('area_code');
        localStorage.removeItem('city_code');
        localStorage.removeItem('bz');
        localStorage.removeItem('type');
        localStorage.removeItem('tim');
        localStorage.removeItem('type');
        localStorage.removeItem('sbsxbz');
        localStorage.removeItem('sbsxIcon');
        localStorage.removeItem('isMn');
        this.$router.push('/login')
      },
      clear(){
        this.userName = ''
      },
      // 密码显示或者隐藏
      shpass() {
        if(this.isPwd){
          this.isPwd = false;
          this.$refs.input.type = "text";
        }else{
          this.isPwd = true;
          this.$refs.input.type = "password";
        }
      },
      login(){
          if(!this.userName) {
              this.$toast.center(this.$t('lg.paccount'));
              return false;
          }
          if(!this.passwords) {
              this.$toast.center(this.$t('lg.ppwd'));
              return false;
          }
          if(this.userName.indexOf('@') > 0){
              this.index = 1
          }else{
              this.index = 0
          }
          let params = {
              account: this.userName,
              password: this.passwords,
              index: this.index,
              sms_code: '',
              token: 1
          }
          this.$ajax.post('/web/userLogin',params).then((res) => {
            let resData = res.data;
            if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                this.isMn = false;
                localStorage.setItem('token',resData.data.token);
                localStorage.removeItem('sbsxbz');
                localStorage.removeItem('sbsxIcon');
                localStorage.removeItem('isMn');
                localStorage.setItem('account',this.userName);
                localStorage.setItem('pwd',this.passwords);
                localStorage.setItem('userId',resData.data.id);
                setTimeout(() => {
                  this.$router.push('/index')
                }, 1000)
            }else{
                this.$toast.center(resData.message);
                return;
            }
          }).catch(function(err){
              console.log(err)
          })
      },
      async getAddress() {
          var that = this;
          let web3Provider = null;
          if (window.ethereum) {
            web3Provider = window.ethereum;
            try {
              await window.ethereum.request({ method: "eth_requestAccounts" });
            } catch (error) {
              console.error("User denied account access");
              return false;
            }
          } else if (window.web3) {
            web3Provider = window.web3.currentProvider;
          } else {
            web3Provider = new Web3.providers.HttpProvider(that.adsHOST);
          }
          if (web3Provider) {
            const Web3address = new Web3(web3Provider);
            try {
              const accounts = await Web3address.eth.getAccounts();
              const address = accounts[0];
              if (address) {
                that.address = address;
                that.getEthLogin();
              } else {
                that.$toast.center('Failed to connect to address');
              }
            } catch (error) {
              that.$toast.center('Failed to connect to address');
            }
          } else {
            that.$toast.center('Failed to connect to address');
          }
      },
      getEthLogin(){//获取地址
        let params = {
            address: this.address,//0xCA62b5Cb65D4dad8AeEea158cB72a4257Fc25E24
        }
        this.$ajax.get('/web/ethLogin',{params}).then((res) => {
          let resData = res.data.data;
          if(res.data.code == 0){
            localStorage.setItem('account',resData.name);
            localStorage.setItem('token',resData.token);
            this.$router.push('/index');
          }else{
            this.$toast.center(res.data.message);
          }
        }).catch(function(err){
            console.log(err)
        })
      },
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .lang{
        position: absolute;
        right: .4rem;
        top: 50%;
        font-size: .5rem;
        transform: translateY(-50%);
    }
    .position-box{
        position: absolute;
        width: 100%;
        height: 100%;
        background: #fff;
    }
    .cotainer{
        position: absolute;
        left: .42rem;
        right: .42rem;
        top: 1.6rem;
        bottom: 0;
        background: #fff;
        overflow-y: scroll;
    }
    .cotainer .h1{
        padding: .8rem 0 .3rem;
        color: #000;
        font-size: .78rem;
    }
    .cotainer .h3{
        color: #9f9f9f;
        font-size: .4rem;
    }
    .cotainer .tips{
        padding-top: .8rem;
        color: #000;
        font-size: .4rem;
    }
    .cotainer .input-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .44rem 0 .38rem;
      border-bottom: .01rem solid #dadada;
    }
    .cotainer .input-box .icon{
      width: .6rem;
    }
    .cotainer .input-box .input::placeholder{
        color: #c5cacd;
        font-size: .4rem;
    }
    .cotainer .input-pwd{
        /* margin-top: 1.3rem; */
    }
    .cotainer .input-box .input{
        width: 100%;
        height: 100%;
        color: #000;
        font-size: .48rem;
    }
    .cotainer .item-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .5rem 0 1.2rem;
        font-size: .4rem;
    }
    .cotainer .btn-login{
        display: block;
        width: 100%;
    }
    .cotainer .btn-login2{
        display: block;
        width: 100%;
        margin-top: .6rem;
        color: #000;
        background: #fff;
        border: solid 0.01rem #000;
    }
    .cotainer .t1{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .6rem 0 .4rem;
      color: #acacac;
      font-size: .4rem;
    }
    .cotainer .t1 .kefu{
      width: 1.2rem;
    }
    .cotainer .t2{
      flex: 1;
      color: #588bf8;
    }
</style>



// WEBPACK FOOTER //
// src/pages/login.vue